import _ from 'lodash'
import { Becy } from '@/components/ui/icon'
import { Footer } from '@/components/layout/footer'
import { PageShell } from '@/components/layout/PageShell'
import { OriginalGameCard } from '@/components/original/OriginalGameCard'
import { OriginalGameCardSkeleton } from '@/components/original/OriginalGameCardSkeleton'
import { getSortedOriginalGames } from '@/lib/original-games'
import { useGetOriginalGamesQuery } from '@/store/api/originalApi'
import { ORIGINAL_SKELETON_COUNT } from '@/config/original'

export default function Originals() {
	const { data, isLoading, isError } = useGetOriginalGamesQuery()
	const games = getSortedOriginalGames(data?.data ?? [])

	return (
		<PageShell gap='6' footer={<Footer />}>
			<div className='flex items-center gap-3'>
				<Becy className='h-7 w-7 text-primary' />
				<h1 className='text-2xl font-semibold tracking-[-0.12px] text-foreground'>BECY Originals</h1>
			</div>

			{isError ? <p className='text-sm text-muted-foreground'>Unable to load original games right now.</p> : null}

			<div className='grid grid-cols-[repeat(auto-fill,150px)] justify-center gap-6'>
				{isLoading ? _.times(ORIGINAL_SKELETON_COUNT, (index) => <OriginalGameCardSkeleton key={`original-game-skeleton-${index}`} />) : null}

				{!isLoading && !isError && _.isEmpty(games) ? (
					<p className='col-span-full text-center text-sm text-muted-foreground'>No original games are available right now.</p>
				) : null}

				{!isLoading && !isError ? _.map(games, (game) => <OriginalGameCard key={game.id} game={game} />) : null}
			</div>
		</PageShell>
	)
}
